// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__ILIqL","slider__ranges":"slider_slider__ranges__bTgKo","slider__range":"slider_slider__range__WxLLj"};